import React, { Suspense, lazy } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Redirect, Switch } from 'react-router-dom';
import { LayoutSplashScreen, ContentRoute } from '../_metronic/layout';
import ProjectsPage from './pages/Projects/ProjectsPage';
import Dashboard from './pages/Dashboard/DashboardRoutes';
import { LoadingProvider } from './contexts/LoadingContext';
import BusinessEntitiesUsersCreate from './pages/Administration/BusinessEntitiesUsersCreate';
import ZonesHome from './pages/Areas/ZonesHome';
import FacilitiesPage from './pages/Facilities/FacilitiesRoutes';
import { shallowEqual, useSelector } from 'react-redux';

const AdministrationPage = lazy(() =>
  import('./pages/Administration/AdministrationRoutes')
);
const AccountPage = lazy(() => import('./pages/Account/AccountRoutes'));
const Devices = lazy(() => import('./pages/Devices/DevicesRoutes'));
const ProcessingGroups = lazy(() =>
  import('./pages/ProcessingGroups/ProcessingGroupsRoutes')
);
const Flows = lazy(() => import('./pages/Flows/FlowsRoutes'));
const Facilities = lazy(() =>
  import('./pages/Facilities/FacilitiesRouteProvider')
);
const Assets = lazy(() => import('./pages/Assets/AssetsRoutes'));
const Applications = lazy(() =>
  import('./pages/Applications/ApplicationsRoutes')
);

export default function BasePage() {
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  return (
    <LoadingProvider>
      <AnimatePresence initial={false} exitBeforeEnter>
        <Suspense fallback={<LayoutSplashScreen />}>
          <Switch>
            {
              /* Redirect from root URL to /dashboard. */
              <Redirect exact from="/" to="/dashboard" />
            }
            <ContentRoute path="/dashboard" component={Dashboard} />
            <ContentRoute path="/infrastructure" component={Devices} />
            <ContentRoute path="/assets-management" component={Assets} />
            <ContentRoute path="/applications" component={Applications} />
            <ContentRoute
              path="/processing-groups"
              component={ProcessingGroups}
            />
            <ContentRoute path="/flows" component={Flows} />
            <ContentRoute
              path="/account/:id/users/:userId"
              component={BusinessEntitiesUsersCreate}
            />
            <ContentRoute path="/projects" component={ProjectsPage} />
            <ContentRoute path="/account" component={AccountPage} />
            {user?.isSuperAdmin && (
              <ContentRoute
                path="/administration"
                component={AdministrationPage}
              />
            )}
            <ContentRoute
              path="/geo-planner/areas"
              component={FacilitiesPage}
            />
            <ContentRoute path="/geo-planner/zones" component={ZonesHome} />
            <ContentRoute
              path="/geo-planner/facilities"
              component={Facilities}
            />
            <Redirect to="/404" />
          </Switch>
        </Suspense>
      </AnimatePresence>
    </LoadingProvider>
  );
}
